import React from "react"
import PropTypes from "prop-types"

// Components
import LinkAdapter from "components/Stacker/components/LinkAdapter/LinkAdapter"

// Styles
import "./ViewDetailsLink.scss"
import { useI18nContext } from "i18n/i18n-react"

function ViewDetailsLink(props) {
  const { url, pid, handleClick } = props
  const { LL } = useI18nContext()
  return (
    <p className="ViewDetailsLink">
      <LinkAdapter
        className="view-full-details"
        to={url}
        customClick={handleClick}
        baseProduct={pid}
      >
        {LL.pdp.viewDetailsText()}
      </LinkAdapter>
    </p>
  )
}

ViewDetailsLink.propTypes = {
  url: PropTypes.string,
  pid: PropTypes.string,
  handleClick: PropTypes.func,
}

export default ViewDetailsLink
